import {Component, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
    selector: 'confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    standalone: false
})
export class ConfirmationModal implements OnInit {

  public confirmationMessage: string;

  constructor(
    public bsModalRef: BsModalRef
  ) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.bsModalRef.hide();
    }, 3000);
  }
}
